module.exports = __webpack_public_path__ + "img/subtitle-1.ee033c9b.svg";